import { render } from "./CustomersPage.vue?vue&type=template&id=784c28ef&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"

import "./CustomersPage.vue?vue&type=style&index=0&id=784c28ef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784c28ef"]])

export default __exports__